module.exports = __webpack_public_path__ + "static/media/ls.75282372.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ls.svg
// module id = 878
// module chunks = 0